import React, { useState } from "react";
import Input, { InputProps } from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import ToggleIcon from "material-ui-toggle-icon";
import {
  Theme,
  createStyles,
  makeStyles,
  InputLabel,
  FormControl,
  InputBaseProps,
} from "@material-ui/core";

interface IPasswordFieldProps {
  id: string;
  label: string;
  props: InputBaseProps;
}

export const PasswordField = ({ id, label, ...props }: any) => {
  const [visible, setVisible] = useState(false);
  const classes = useStyles();
  const handleButtonMouseDown = (e) => {
    e.preventDefault();
  };
  return (
    <FormControl fullWidth>
      <InputLabel id={`custom-password-${id}`}>{label}</InputLabel>
      <Input
        {...props}
        id={id}
        className={{ root: classes.root, input: classes.input }}
        type={visible ? "text" : "password"}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              onClick={() => setVisible(!visible)}
              onMouseDown={handleButtonMouseDown}
            >
              <ToggleIcon
                on={visible}
                onIcon={<Visibility />}
                offIcon={<VisibilityOff />}
              />
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    input: {},
  })
);
